module.exports = __webpack_public_path__ + "img/back_03.89102ffa.png";